
export default function Contact() {
  return (
    <section id="contact" className="bg-slate-900 text-white">
      <div className="py-32 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-8 text-center">
          <h2 className="text-7xl font-bold mb-8">
            Ready to Enhance Your<br />Mobile Security?
          </h2>
          
          <p className="text-xl text-slate-400 mb-12 max-w-2xl mx-auto">
            Join thousands of users who trust BRANKOR DOO applications to protect and optimize their iOS devices.
          </p>
          
          <p className="text-lg font-semibold text-cyan-400">
            Experience the difference with our innovative solutions
          </p>
        </div>
      </div>

      <div className="py-20">
        <div className="max-w-7xl mx-auto px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/3e57f6d02b0df5a16e2b9a1ff39fff28.jpg"
                alt="Office Workspace"
                className="w-full h-48 object-cover rounded-2xl shadow-xl"
              />
            </div>

            <div className="lg:col-span-4">
              <p className="text-4xl font-serif text-slate-400 leading-relaxed">
                Building the future<br />
                of mobile<br />
                applications
              </p>
            </div>

            <div className="lg:col-span-5">
              <div className="mb-8">
                <h3 className="text-xs uppercase tracking-widest text-slate-500 mb-6 font-medium">
                  Get In Touch
                </h3>
              </div>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-map-pin-line text-cyan-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-slate-500 mb-1">Address</p>
                    <p className="text-base text-white">Petra Kocica 9</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-building-line text-cyan-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-slate-500 mb-1">City</p>
                    <p className="text-base text-white">Niska Banja</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-mail-line text-cyan-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-slate-500 mb-1">Zip</p>
                    <p className="text-base text-white">708344</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-global-line text-cyan-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-slate-500 mb-1">Country</p>
                    <p className="text-base text-white">Serbia</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-mail-send-line text-cyan-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-slate-500 mb-1">Email</p>
                    <p className="text-base text-white">help@brankordoo.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-phone-line text-cyan-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-slate-500 mb-1">Number</p>
                    <p className="text-base text-white">+1 8057060946</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800 py-8">
        <div className="max-w-7xl mx-auto px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/c2c58b8e-fe26-41d7-95e5-fc329b10f567.png" 
                alt="BRANKOR DOO Logo" 
                className="h-8 w-8 object-contain"
              />
              <p className="text-sm text-slate-400">
                © 2025 BRANKOR DOO. All rights reserved.
              </p>
            </div>
            
            <p className="text-sm text-slate-500">
              Developing modern applications for iOS platform
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
